import { Dialog, DialogTitle } from '@mui/material';

import DeleteAccountForm from './DeleteAccountForm';

interface DeleteAccountDialogProps {
  open: boolean;
  onClose(): void;
}

const DeleteAccountDialog = ({ open, onClose }: DeleteAccountDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Видалення облікового запису</DialogTitle>
      <DeleteAccountForm />
    </Dialog>
  );
};

export default DeleteAccountDialog;
